import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row, Avatar, Layout } from 'antd';
import CircleCheckIcon from 'components/Icons/CircleCheckIcon';
import PatronsLogos from 'components/Icons/PatronsLogos';
import { PERKS_LIST_1, PERKS_LIST_2 } from 'constants/index';
import images from 'constants/images';

const { Sider } = Layout;

const Perks = ({ user, usersTeam, newUsersCount }) => {
  const renderFeaturesList = (list, isActive) => {
    return list.map((item) => (
      <Row key={item.text} className={`feature-list ${isActive ? '' : 'feature-list-disabled'}`}>
        <CircleCheckIcon className="feature-list-check-icon" />
        <div className="feature-list-info">
          <span className="feature-list-text">{item.text}</span>
        </div>
      </Row>
    ));
  };

  return (
    <Sider width={530} className="plans-info-sider" breakpoint="sm" collapsedWidth="50">
      <Col span={24} className="plans-info">
        <p className="plans-information-header">What Prospero can do for you</p>
        <Row className="plans-information">
          <Col span={10} className="gutter-row">
            {renderFeaturesList(PERKS_LIST_1, true)}
          </Col>
          <Col span={14} className="gutter-row">
            {renderFeaturesList(PERKS_LIST_2, true)}
          </Col>
        </Row>
      </Col>
      <Col className="plans-review">
        <Col span={24} className="testimony">
          <Row className="plans-reviewer">
            <Avatar src={images.PLAN} size={64} />
            <Col className="plans-reviewer-info">
              <h3 className="author-name">Hadar Chen</h3>
              <span className="author-title">Co-founder at Hunt Digital</span>
            </Col>
          </Row>
          <p className="comment">
            “Prospero is helping us to achieve exhilarating and invigorating results. We're
            receiving more”
          </p>
        </Col>
        <PatronsLogos className="plans-review-service-icon" />
      </Col>
    </Sider>
  );
};

Perks.propTypes = {
  user: PropTypes.instanceOf(Object).isRequired,
  usersTeam: PropTypes.instanceOf(Array),
  newUsersCount: PropTypes.number,
};

export default Perks;
